// extracted by mini-css-extract-plugin
export default {"newToastContainer":"Toast-module--newToastContainer--a2c83"};